import React, { Component } from 'react';
import Inherit from '../../core/inherit';
import withHooks from '../../core/withHooks';
import SignupSuccessController from './signup-success.controller';
import { Button as AntButton } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import styles from './styles/signup-success.module.scss';

/**
 * @extends ClockoutController
 * @extends SignupSuccessController
 * @extends Component
 */
class SignupSuccess extends Inherit(SignupSuccessController, Component) {
    render() {
        return (
            <div className={styles.successContainer}>
                <div className={styles.leftSection}>
                    <div className={styles.logoContainer}>
                        <img src="/logo-color.png" alt="Clockout Logo" className={styles.logo} />
                    </div>
                    
                    <div className={styles.contentWrapper}>
                        <div className={styles.headerSection}>
                            <h1 className={styles.title}>Welcome to Clockout</h1>
                            <p className={styles.subtitle}>
                                Continue to set up and configure your Earned Wage Access service.
                            </p>
                        </div>

                        <div className={styles.imageSection}>
                            <img src="/phone-ux.png" alt="Clockout App Preview" className={styles.phoneImage} />
                        </div>
                    </div>
                </div>

                <div className={styles.rightSection}>
                    <div className={styles.formHeader}>
                        <span className={styles.alreadyHaveAccount}>Already have an account?</span>
                        <AntButton 
                            type="text" 
                            onClick={() => this.navigateToSignIn()}
                            className={styles.signInButton}
                        >
                            Sign in
                        </AntButton>
                    </div>

                    <div className={styles.successCard}>
                        <div className={styles.successContent}>
                            <div className={styles.checkmarkWrapper}>
                                <div className={styles.checkmarkCircle}>
                                    <CheckCircleOutlined className={styles.checkmarkIcon} />
                                </div>
                            </div>
                            
                            <h2 className={styles.successTitle}>Account Setup Complete!</h2>
                            <p className={styles.successSubtitle}>Welcome to Clockout.</p>

                            <AntButton
                                type="primary"
                                size="large"
                                onClick={() => this.continueToDashboard()}
                                className={styles.continueButton}
                                block
                            >
                                Continue
                            </AntButton>
                        </div>
                    </div>
                </div>

                <div className={styles.footer}>
                    <span className={styles.copyright}>Copyright © 2025 Clockout Financial Inc.</span>
                    <div className={styles.footerLinks}>
                        <a href="/terms" className={styles.footerLink}>Terms and Conditions</a>
                        <a href="/privacy" className={styles.footerLink}>Privacy Policy</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default withHooks(SignupSuccess);

